import actionTypes from "../actions/types";
export const initialMaintenanceState = {
  isEdited: undefined,
  groups: [],
};

export const maintenanceReducer = (state = initialMaintenanceState, action) => {
  switch (action.type) {
    case actionTypes.SET_GROUPS:
      const isEdited =
        JSON.stringify(state.groups) !== JSON.stringify(action.payload.groups);
      return {
        ...state,
        groups: action.payload.groups,
        isEdited,
      };
    case actionTypes.SET_GROUP:
      let newGroups = state.groups.map((group, index) => {
        if (index === action.payload.index) {
          return {
            ...state.groups[index],
            ...action.payload.group,
            isEdited: true,
          };
        } else return group;
      });
      const isEdited2 =
        JSON.stringify(state.groups) !== JSON.stringify(newGroups);
      return {
        ...state,
        groups: newGroups,
        isEdited: isEdited2,
      };
    case actionTypes.SET_ITEMS:
      return {
        ...state,
        items: action.payload.items,
      };
    case actionTypes.SET_ITEM:
      let newMaintenanceGroup = state.groups.map((group, index) => {
        if (index === action.payload.groupIndex) {
          return {
            ...state.groups[index],
            ...action.payload.group,
            items: state.groups[index]["items"].map((element, i) => {
              if (i === action.payload.index) {
                return action.payload.item;
              } else return element;
            }),
          };
        } else return group;
      });
      return {
        ...state,
        groups: newMaintenanceGroup,
      };
    default:
      return state;
  }
};
